import { render, staticRenderFns } from "./historyRename.vue?vue&type=template&id=4d448acb&scoped=true"
import script from "./historyRename.vue?vue&type=script&lang=js"
export * from "./historyRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d448acb",
  null
  
)

export default component.exports